module.exports = __webpack_public_path__ + "static/img/jigou-ningbo-top.5632b7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-ningbo-top.jpg
// module id = 0RXo
// module chunks = 2